import { useMemo } from 'react';
import PdfPreview from 'components/ShareDocument/SharePreviewContent/PdfPreview';
import DocxPreview from 'components/ShareDocument/SharePreviewContent/DocxPreview';
import ImagePreview from 'components/ShareDocument/SharePreviewContent/ImagePreview';
import OfficePreview from 'components/ShareDocument/SharePreviewContent/OfficePreview';
import UnsupportedPreview from 'components/ShareDocument/SharePreviewContent/UnsupportedPreview';
import SharePreviewToolbar from 'components/ShareDocument/SharePreviewContent/SharePreviewToolbar';
import {
  IMAGE_PREVIEW_EXTENSIONS,
  OFFICE_PREVIEW_EXTENSIONS,
  SharePreviewProps,
  getFileExtension,
} from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

export {
  getFileExtension,
  getOfficePreviewEmbedUrl,
} from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

const SharePreviewContent = ({ url, filename }: SharePreviewProps) => {
  const extension = useMemo(() => getFileExtension(filename, url), [filename, url]);
  const previewProps = { url, filename };

  // PDF ships its own toolbar (zoom + pagination) and scroll container.
  if (extension === 'pdf') {
    return <PdfPreview {...previewProps} />;
  }

  let body = <UnsupportedPreview />;
  if (extension === 'docx') {
    body = <DocxPreview {...previewProps} />;
  } else if (IMAGE_PREVIEW_EXTENSIONS.includes(extension)) {
    body = <ImagePreview {...previewProps} />;
  } else if (OFFICE_PREVIEW_EXTENSIONS.includes(extension)) {
    body = <OfficePreview {...previewProps} />;
  }

  return (
    <div className='rounded border-general border-grey-50'>
      <SharePreviewToolbar url={url} filename={filename} />
      <div className='attachment-preview-height-container'>{body}</div>
    </div>
  );
};

export default SharePreviewContent;
